// extracted by mini-css-extract-plugin
export default {"bgVid":"Header_bgVid__Y-RWH","rowHeader":"Header_rowHeader__XHCEG"};